// src/services/api.ts
import axios, { type AxiosResponse } from 'axios';

// 환경변수에서 API URL 설정
const API_BASE_URL =
  import.meta.env.VITE_PUBLIC_PROTOCOL + import.meta.env.VITE_PUBLIC_API || 'http://www.dp.test:8000/v1';

// 공통 axios 인스턴스 생성
export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request 인터셉터
api.interceptors.request.use(
  (config) => {
    // 인증 토큰이 있다면 헤더에 추가
    const token = localStorage.getItem('jwtToken');
    if (token) {
      if (config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // 파라미터 정리 (undefined, null, 빈 문자열 제거)
    if (config.params) {
      config.params = Object.fromEntries(
        Object.entries(config.params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
      );
    }

    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  },
);

// Response 인터셉터
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => {
    console.error('❌ Response Error:', error.response?.status, error.response?.data);

    // 401 에러 시 로그아웃 처리
    if (error.response?.status === 401) {
      localStorage.removeItem('jwtToken');
      window.location.href = '/signin';
    }

    return Promise.reject(error);
  },
);

// 공통 파라미터 타입
export interface BasePaginationParams {
  page?: number;
  per_page?: number;
}

export interface BaseFilters {
  search?: string;
  status?: string;
}
